/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StorageDetails
 */
export interface StorageDetails {
    /**
     * 
     * @type {number}
     * @memberof StorageDetails
     */
    storageUsed: number;
    /**
     * 
     * @type {number}
     * @memberof StorageDetails
     */
    storageLeft?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageDetails
     */
    totalAvailableStorage?: number;
}

export function StorageDetailsFromJSON(json: any): StorageDetails {
    return StorageDetailsFromJSONTyped(json, false);
}

export function StorageDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'storageUsed': json['storageUsed'],
        'storageLeft': !exists(json, 'storageLeft') ? undefined : json['storageLeft'],
        'totalAvailableStorage': !exists(json, 'totalAvailableStorage') ? undefined : json['totalAvailableStorage'],
    };
}

export function StorageDetailsToJSON(value?: StorageDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'storageUsed': value.storageUsed,
        'storageLeft': value.storageLeft,
        'totalAvailableStorage': value.totalAvailableStorage,
    };
}


